import { createRoot } from 'react-dom/client'
import { LogoFooterWidget } from './LogoFooterWidget.jsx'

const selector = '[data-nova-logo-footer]'

function parsePayload(element) {
  try {
    return JSON.parse(element.dataset.payload || '{}')
  } catch {
    return {}
  }
}

function mountLogoFooter(element) {
  if (element.__novaReactRoot) return

  element.__novaReactRoot = createRoot(element)
  element.__novaReactRoot.render(<LogoFooterWidget payload={parsePayload(element)} />)
}

function mountLogoFooters(root = document) {
  if (root.matches?.(selector)) {
    mountLogoFooter(root)
  }

  root.querySelectorAll?.(selector).forEach(mountLogoFooter)
}

mountLogoFooters()

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        mountLogoFooters(node)
      }
    })
  })
})

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
})
